import { CCPOfferingContent } from "src/contentful";

import { CloudOfferingKey, OfferingSKUMap } from "../../constants";

export const usePricingPlan = (
    skip: boolean,
    offeringSku: string,
    currencyISOCode: string,
    edition: string,
    billingCycle: string,
    ccpPricingData: OfferingSKUMap<CloudOfferingKey, CCPOfferingContent>
) => {
    if (skip) {
        return {
            pricingPlanId: ""
        };
    }

    const defaultPricingPlan = ccpPricingData[
        offeringSku.toLowerCase()
    ]?.defaultPricingPlans?.filter(
        (item) =>
            item.currency.toLowerCase() == currencyISOCode.toLowerCase() &&
            item.offeringName.toLowerCase() == edition.toLowerCase() &&
            item.primaryCycle_name.toLowerCase() ==
                billingCycle.toLowerCase() &&
            item.status.toLowerCase() == "active"
    );

    const lastPricingPlan = defaultPricingPlan?.[defaultPricingPlan.length - 1];

    return {
        pricingPlanId: lastPricingPlan?.id || ""
    };
};
